import { render } from "./BatchFormAlerts.vue?vue&type=template&id=af82a124"
import script from "./BatchFormAlerts.vue?vue&type=script&lang=js"
export * from "./BatchFormAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__